import type { JSX } from 'react';
import type { WireSourceHealthRow } from '@logistics/contracts';
import { cn } from '@/lib/utils';
import { statusLook } from './status';

/** "● Connected" in the status colour. */
export function StatusDot({
  status,
  className,
}: {
  status: WireSourceHealthRow['status'];
  className?: string;
}): JSX.Element {
  const { color, label } = statusLook(status);
  return (
    <span className={cn('flex items-center gap-1.5 text-xs', className)} style={{ color }}>
      <span className="size-[7px] flex-none rounded-full" style={{ background: color }} />
      {label}
    </span>
  );
}
